import React from 'react';
import { activeProject } from '../../data/mockData';
import CameraFrame from '../../components/ui/CameraFrame';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPackage, FiUsers, FiAlertCircle } = FiIcons;

const Logistics = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 animate-in fade-in duration-500">
      
      {/* Props & Gear */}
      <div className="space-y-4">
        <h3 className="font-mono text-lg text-white tracking-widest uppercase flex items-center gap-2 pb-2 border-b border-[#222]">
          <SafeIcon icon={FiPackage} className="text-[#666]" /> Props & Gear
        </h3>
        
        <CameraFrame className="bg-[#111]">
          <div className="overflow-x-auto">
            <table className="w-full text-left font-mono text-sm">
              <thead className="bg-[#1a1a1a] text-[#666] text-xs uppercase tracking-wider">
                <tr>
                  <th className="p-4 border-b border-[#333]">Item</th>
                  <th className="p-4 border-b border-[#333]">Source</th>
                  <th className="p-4 border-b border-[#333]">Status</th>
                </tr>
              </thead>
              <tbody className="text-[#ccc]">
                {activeProject.logistics.props.map((prop, i) => (
                  <tr key={prop.id} className="border-b border-[#222] hover:bg-[#1a1a1a] transition-colors">
                    <td className="p-4">{prop.item}</td>
                    <td className="p-4 text-[#888]">{prop.owner}</td>
                    <td className="p-4">
                      <span className={`px-2 py-1 text-[10px] uppercase tracking-wider border ${
                        prop.status === 'packed' ? 'text-green-500 border-green-500/30' :
                        prop.status === 'missing' ? 'text-pink-500 border-pink-500/50 bg-pink-500/10' :
                        'text-yellow-500 border-yellow-500/30'
                      }`}>
                        {prop.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CameraFrame>

        {activeProject.logistics.props.some(p => p.status === 'missing') && (
          <div className="p-3 border border-pink-500/50 bg-pink-500/10 flex items-start gap-3">
            <SafeIcon icon={FiAlertCircle} className="text-pink-500 shrink-0 mt-0.5" />
            <p className="font-mono text-xs text-pink-500/90 tracking-wide uppercase">
              Warning: Critical props marked as missing. Rectify before shoot date.
            </p>
          </div>
        )}
      </div>

      {/* Crew Manifest */}
      <div className="space-y-4">
        <h3 className="font-mono text-lg text-white tracking-widest uppercase flex items-center gap-2 pb-2 border-b border-[#222]">
          <SafeIcon icon={FiUsers} className="text-[#666]" /> Call Sheet / Crew
        </h3>

        <div className="grid gap-3">
          {activeProject.logistics.crew.map((member, i) => (
            <CameraFrame key={i} className="p-4 bg-[#111] flex items-center justify-between">
              <div>
                <p className="font-mono text-xs text-[#666] uppercase tracking-widest mb-1">{member.role}</p>
                <p className="text-white font-bold">{member.name}</p>
              </div>
              <div className="text-right">
                <p className="font-mono text-[10px] text-green-500 uppercase tracking-widest border border-green-500/30 px-2 py-1">Confirmed</p>
              </div>
            </CameraFrame>
          ))}
        </div>

        <button className="w-full py-3 border border-[#333] border-dashed text-[#666] hover:text-white hover:border-[#666] transition-colors font-mono text-xs uppercase tracking-widest mt-4">
          + Add Crew Member
        </button>
      </div>

    </div>
  );
};

export default Logistics;